import axios from 'axios'
import type { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'


export const api = axios.create({
  baseURL: '/api/hub',
  withCredentials: true
})

api.interceptors.response.use(response => {
  const ray = response.headers['cf-ray'] ?? response.headers['CF-RAY']
  Sentry.setTag('cf_ray', String(ray ?? ''))

  return response
}, (error: AxiosError) => {
  const ray = error.response?.headers?.['cf-ray'] ?? error.response?.headers?.['CF-RAY']
  Sentry.setTag('cf_ray', String(ray ?? ''))

  return Promise.reject(error)
})
